export interface CableSizingStandard {
    code: number;
    label: string;
    name: string;
    calculationType: number;
}

export const CABLE_SIZING_STANDARDS: CableSizingStandard[] = [
    { code: 0, label: 'AS', name: 'AS/NZS 3008.1.1 (Australian)', calculationType: 1 },
    { code: 1, label: 'NZ', name: 'AS/NZS 3008.1.2 (New Zealand)', calculationType: 13 },
    { code: 2, label: 'BS', name: 'BS 7671 (British)', calculationType: 3 },
    { code: 3, label: 'IEC', name: 'IEC 60364-5-52 (International)', calculationType: 9 },
    { code: 4, label: 'NEC', name: 'NEC NFPA 70 (United States)', calculationType: 12 },
];

export function standardNameLabel(name: string): string {
    return name.replace(/\s*\([^)]*\)\s*$/, '');
}

export function standardNameRegion(name: string): string {
    return name.match(/\([^)]*\)\s*$/)?.[0] ?? '';
}
